var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"site-nav-wrap xs-12",class:{ open: _vm.siteNavMobileNavOpen }},[(_vm.showMobileNav)?[_c('SiteNavMobile')]:[_c('SiteNavDesktop')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }